import { useMutation, useQueryClient } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';
import { Database } from '@/_constants/database.types';

type PaperAttempt = Database['public']['Tables']['past_paper_attempts']['Row'];

interface SubmitAttemptParams {
  attemptId: string;
}

const useSubmitAttempt = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ attemptId }: SubmitAttemptParams): Promise<PaperAttempt> => {
      // Call submit-attempt edge function which handles all grading server-side
      const { data, error } = await supabaseClient.functions.invoke('submit-attempt', {
        body: {
          attempt_id: attemptId,
        },
      });

      if (error) {
        console.error('Failed to submit attempt:', error);
        throw error;
      }

      console.log('Submission response:', data);

      // Fetch the updated attempt to return
      const { data: attemptData, error: fetchError } = await supabaseClient
        .from('past_paper_attempts')
        .select()
        .eq('id', attemptId)
        .single();

      if (fetchError) throw fetchError;

      return attemptData;
    },
    onSuccess: (data) => {
      // Invalidate the attempt query
      queryClient.invalidateQueries({ queryKey: ['paper_attempt', data.id] });
      // Invalidate answer queries
      queryClient.invalidateQueries({ queryKey: ['attempt_answers', data.id] });
      // Invalidate attempts list
      queryClient.invalidateQueries({ queryKey: ['past_paper_attempts', data.past_paper_id, data.auth_id] });
    },
  });
};

export default useSubmitAttempt;
